import { create } from 'zustand';

import { IContextState, IInitialState } from './interfaces';

const initialState: IInitialState = {
  open: false,
};

export const useFeedbackModal = create<IContextState>((set) => ({
  ...initialState,
  setOpen: (open) => set({ open }),
  toggleOpen: () => set((state) => ({ open: !state.open })),
}));
